<div class="modal-overlay" (click)="onFechar()"></div>

<div class="modal-container">
  <div class="modal-header">
    <h3 class="modal-title">{{ titulo }}</h3>
    <button class="modal-close-button" (click)="onFechar()">
      &times;
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
    <div class="col-md-6">
        <p><strong>PU/LF Code <br/>CÓDIGO DA FAZENDA:</strong><br/> {{ dados?.numeroCertificadoBCI }}</p>
        <p><strong>PU/LF Name <br/>NOME DA UNIDADE PRODUTIVA:</strong><br/> {{ dados?.nomeUnidadeProdutiva | uppercase }}</p>
        <p><strong>State Base ESTADUAL:</strong><br/> {{ dados?.uf }}</p>
        <p><strong>Group Name <br/>Nome do Grupo <br/>(new - Due Diligence):</strong><br/> {{ dados?.produtorGrupo | uppercase }}</p>
        <p><strong>LF/PU City <br/>MUNICÍPIO:</strong><br/> {{ dados?.municipio | uppercase }}</p>
        <p><strong>LF/PU State <br/>Nome da UF:</strong><br/> {{ dados?.uf }}</p>
        <p><strong>LF/PU Adress <br/>Endereço da Unidade Produtiva:</strong><br/> {{ dados?.endereco }}</p>
        </div>
        <div class="col-md-6">
        
        <p><strong>LF/PU Geolocation (Latitude)<br/>(new - traceability):</strong><br/> {{ dados?.latitude }}</p>
        <p><strong>LF/PU Geolocation (Longitude) <br/>(new - traceability):</strong><br/> {{ dados?.longitude }}</p>
        <p><strong>LF/PU Owner <br/>PROPRIETÁRIO DA FAZENDA:</strong><br/> {{ dados?.nomeUnidadeProdutiva }}</p>
        <p><strong>Area under Cotton Production (ha) <br/>ÁREA PLANTADA (ha):</strong><br/> {{ dados?.areaAlgodao | number | replaceNumber}}</p>
        <p><strong>Licensed Area (ha) <br/>ÁREA LICENCIADA (ha):</strong><br/> {{ getAreaConversao(dados) | number | replaceNumber}}</p>
        <p><strong>Lint yield per hectare (Kg /ha) <br/>PRODUTIVIDADE PLUMA (kg/ha):</strong><br/> {{ dados?.produtividadePluma | number | replaceNumber}}</p>
        <p><strong>Lint Production (kg)  <br/> PRODUÇÃO PLUMA (kg):</strong><br/> {{ calcularProducaoPluma(dados) | number | replaceNumber}}</p>
        
    </div>
    </div>
    
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-success" (click)="exportarGridParaExcel()">Gerar excel</button>
    <button class="btn btn-secondary" (click)="onFechar()">Fechar</button>
    </div>
</div>
